import WatchAccessAllowed from './WatchAccessAllowed'

export default WatchAccessAllowed
// eslint-disable-next-line import/export
export * from './WatchAccessAllowed'
